document.addEventListener('DOMContentLoaded', function() {

  // 現在のカレンダー設定
  const calendarElCurrent = document.getElementById('current-month');
  let calendarCurrent = new FullCalendar.Calendar(calendarElCurrent, {
    googleCalendarApiKey: 'AIzaSyD8ttebBxfO019eMNL_172mIXUBsL5H2VE',
    eventSources: [
      {
        googleCalendarId: 'f408db444608f3c12ab42d957bc0b8d27c833b3d454e5e4186dddaecad482f79@group.calendar.google.com', // 休業日
        display: 'background',
        className: 'gcal-holiday'
      },
      {
        googleCalendarId: '034896d32950191b917c0365094aa1508c2e452a5a49762ae8e541bc44188955@group.calendar.google.com', // 出荷業務
        display: 'background',
        className: 'gcal-event'
      }
    ],
    initialView: 'dayGridMonth', // デフォルトを月表示にする
    headerToolbar: {
      left: '',
      center: 'title',
      right: 'prev,today,next' // ボタンの並び順
    },
    locale: 'ja', // 日本語表示設定
    dayCellContent: function (e) {
      e.dayNumberText = e.dayNumberText.replace('日', ''); // 日付から「日」を削除
    },
    fixedWeekCount: false, // 6週間表示をやめる
    contentHeight: 226, // 初期のカレンダー本体の高さ
    aspectRatio: 1, // カレンダーサイズのアスペクト比

    // カレンダー表示後に行数を取得
    datesSet: function(info) {
      let startDate = new Date(info.view.currentStart);
  
      // 月末の日付を取得
      let endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0);
  
      // 1日の曜日を取得
      let firstDayOfWeek = startDate.getDay();
  
      // 月の日数を取得
      let totalDays = endDate.getDate();
  
      // 週数を計算
      let totalWeeks = Math.ceil((totalDays + firstDayOfWeek) / 7);
  
      // 高さを決定
      let newHeight = (totalWeeks === 4) ? 190 : (totalWeeks === 5) ? 226 : 262;

      // カレンダーの高さを設定
      calendarCurrent.setOption('contentHeight', newHeight);
    }
  });

  calendarCurrent.render();

  // 来月のカレンダー設定
  const calendarElNext = document.getElementById('next-month');
  let calendarNext = new FullCalendar.Calendar(calendarElNext, {
    googleCalendarApiKey: 'AIzaSyD8ttebBxfO019eMNL_172mIXUBsL5H2VE',
    eventSources: [
      {
        googleCalendarId: 'f408db444608f3c12ab42d957bc0b8d27c833b3d454e5e4186dddaecad482f79@group.calendar.google.com', // 休業日
        display: 'background',
        className: 'gcal-holiday'
      },
      {
        googleCalendarId: '034896d32950191b917c0365094aa1508c2e452a5a49762ae8e541bc44188955@group.calendar.google.com', // 出荷業務は行っておりません
        display: 'background',
        className: 'gcal-event'
      },
    ],
    initialView: 'dayGridMonth', // デフォルトを月表示にする
    headerToolbar: {
      left: '',
      center: 'title',
      right: 'prev,today,next'//ボタンの並び順
    },
    locale: 'ja', // 日本語表示設定
    dayCellContent: function (e) {
      e.dayNumberText = e.dayNumberText.replace('日', ''); // 日付のセルから日を削除
    },
    fixedWeekCount: false, // 6週間表示をやめる
    aspectRatio: 1, // カレンダーサイズのアスペクト比
    initialDate: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1), // 来月の初日を設定

    datesSet: function(info) {
      // 現在の月の開始日を取得
      let startDate = new Date(info.view.currentStart);
  
      // 月末の日付を取得
      let endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0);
  
      // 1日の曜日を取得
      let firstDayOfWeek = startDate.getDay();
  
      // 月の日数を取得
      let totalDays = endDate.getDate();
  
      // 週数を計算
      let totalWeeks = Math.ceil((totalDays + firstDayOfWeek) / 7);
  
      // 高さを決定
      let newHeight = (totalWeeks === 4) ? 190 : (totalWeeks === 5) ? 226 : 262;
  
      // カレンダーの高さを設定
      calendarNext.setOption('contentHeight', newHeight);
    }
  });

  calendarNext.render();
  });